import type { ID } from '@octopus-do/octopus-project-core'
import { Archive as ArchiveIcon } from '@octopus-do/octopus-storybook/icons'
import type { WorkspaceItem } from '@store/reducers/dashboard/types'
import { countOwnProjects } from '@store/reducers/dashboard/utils'
import type React from 'react'

import { PROJECTS_COUNT_CLASS_NAME } from '../../Folders'
import { FolderContainer } from '../FolderContainer'
import { FolderLink } from '../FolderLink'

interface Props {
  folder: WorkspaceItem
  workspaceId: ID
  activeFolder: string | null
}

export const ArchiveFolder: React.FC<Props> = ({
  workspaceId,
  folder,
  activeFolder,
}) => {
  const { title, id } = folder

  const active = activeFolder === id
  const count = countOwnProjects(folder)

  return (
    <FolderContainer active={active}>
      <FolderLink
        activeFolder={activeFolder}
        workspace={{ id: workspaceId }}
        folderId={id}
        title={title}
      >
        <ArchiveIcon />
      </FolderLink>

      {!!count && <div className={PROJECTS_COUNT_CLASS_NAME}>{count}</div>}
    </FolderContainer>
  )
}
